import { Box, TableCell, TableRow, Typography } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { WD } from '../../../warningDashboard/warningTheme';
import { FIGURE, LEVEL_TONE } from '../utils/constants';
import { fmtHours } from '../utils/hours';
import PersonAvatar from './PersonAvatar';
import LoadBar from './LoadBar';
import LoadPercent from './LoadPercent';
import LoadTag from './LoadTag';

/** One person in the "Allocation by person" table (md and up). The whole row opens them, by click or Enter / Space. */
export default function PersonRow({ row, onOpen }) {
  const open = () => onOpen(row.person.id);

  return (
    <TableRow
      hover
      tabIndex={0}
      onClick={open}
      onKeyDown={(event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open();
      }}
      sx={{ cursor: 'pointer' }}
    >
      <TableCell sx={{ pl: 2.5, py: 1.25 }}>
        <Box display="flex" alignItems="center" gap={1.5} sx={{ minWidth: 0 }}>
          <PersonAvatar person={row.person} size={36} />
          <Box sx={{ minWidth: 0 }}>
            <Typography noWrap sx={{ fontSize: 13.5, fontWeight: 600, color: WD.ink }}>
              {row.person.name}
              {row.person.isYou && <Box component="span" sx={{ ml: 0.75, fontSize: 11, fontWeight: 500, color: WD.inkFaint }}>(you)</Box>}
            </Typography>
            <Typography noWrap sx={{ fontSize: 12, color: WD.inkFaint }}>{row.person.title || '-'}</Typography>
          </Box>
        </Box>
      </TableCell>
      <TableCell align="right" sx={{ ...FIGURE, fontSize: 13.5 }}>
        {row.tasks}
        {row.needsHours > 0 && (
          <Typography component="span" title="Tasks with no hours set yet" sx={{ display: 'block', fontSize: 10.5, fontWeight: 700, color: LEVEL_TONE.atCapacity.text }}>
            {row.needsHours} need hours
          </Typography>
        )}
      </TableCell>
      <TableCell sx={{ ...FIGURE, fontSize: 13.5 }}>
        <b>{fmtHours(row.allocated)}</b>
        <Box component="span" sx={{ color: WD.inkFaint }}> / {fmtHours(row.capacity)}</Box>
      </TableCell>
      <TableCell align="right" sx={{ ...FIGURE, fontSize: 13, color: WD.inkMuted }}>{fmtHours(row.logged)}</TableCell>
      <TableCell>
        <Box display="flex" alignItems="center" gap={1.5}>
          <LoadBar pct={row.pct} level={row.level} />
          <LoadPercent row={row} />
        </Box>
      </TableCell>
      <TableCell><LoadTag level={row.level} /></TableCell>
      <TableCell align="right" sx={{ color: WD.inkFaint }}><ChevronRightRoundedIcon fontSize="small" /></TableCell>
    </TableRow>
  );
}
